var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "message-box dialog-mask" }, [
    _c(
      "div",
      {
        staticClass: "dialog-content",
        attrs: {
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "yes-no-dialog-title",
        },
      },
      [
        _c("header", { staticClass: "dialog-header" }, [
          _c(
            "h2",
            {
              staticClass: "dialog-title",
              attrs: { id: "yes-no-dialog-title" },
            },
            [_vm._v(_vm._s(_vm.dialogTitle))]
          ),
          _c(
            "button",
            {
              staticClass: "close-icon-btn",
              attrs: { type: "button", "aria-label": _vm.closeAriaLabel },
              on: {
                click: function ($event) {
                  return _vm.$close(false)
                },
              },
            },
            [_c("IconClose")],
            1
          ),
        ]),
        _c("div", { staticClass: "dialog-body" }, [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } }),
        ]),
        _c("footer", [
          _c("div", { staticClass: "button-area" }, [
            _c(
              "button",
              {
                staticClass: "button",
                class: _vm.okVariant,
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$close(true)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.okButton || _vm.$t("common.yes")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "button cancel",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$close(false)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.cancelButton || _vm.$t("common.cancel")) +
                    " "
                ),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }